import React, { Component } from "react";
import { connect } from "react-redux";

import Assets from "../Components/AdmidCard";

import {
    addUploadAsset,
    addAsset,
    Userdetails,
    setNeetatm,
    setNeet,
    setTowClgfullmarksec,
    setTowClgfullmark,
    setTowClgpass,
    setTowClgBord,
    setTowClg,
    setTenSclfullmarksec,
    setTenSclfullmark,
    setTenSclpass,
    setTenSclBord,
    setTenScl,
    setPin,
    setvillage,
    setBlock,
    setDist,
    setSaste,
    setWp,
    serDisabilities,
    setGender,
    setMname,
    setFname,
    SetprofileCat,
    setCitycenter
  } from "../actions"
 
import {
  close_snack_bar
} from "../../../common/snackbar/action";
import {
  onLogout
} from "../../../auth/actions";

export class Controller extends Component {
  render() {
    return (
      <Assets {...this.props} />
    );
  }
};
export const mapStateToProps = store => {
  return {
    assets: store.assets,
    snackbar: store.snackbar,
    login: store.login,
    loader:store.loader
  };
};
export const mapDispatchToProps = dispatch => {
  return {
    Userdetails:(id)  => {
      dispatch(Userdetails(id) )
    },
    // addAsset:(org_id,assets_name, duration, attachmnet)  => {
    //   dispatch(addAsset(org_id,assets_name, duration, attachmnet) )
    // },
    addAsset:(id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
      state, dist, block, village, pin, tenth, tenboard, tenfullmark, tenfullmarksecured, twoth, twoboard, twofullmark, twofullmarksecured,
      neet, neetatm,aadharcertif,disabilities_pic,neet_pic,profile_pictenyrpassing,tenthmarksheet,twothmarksheet, tenyrpassing,twoyrpassing,exmacenter)  => {
      dispatch(addAsset(id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
        state, dist, block, village, pin, tenth, tenboard, tenfullmark, tenfullmarksecured, twoth, twoboard, twofullmark, twofullmarksecured,
        neet, neetatm,aadharcertif,disabilities_pic,neet_pic,profile_pictenyrpassing,tenthmarksheet,twothmarksheet,tenyrpassing,twoyrpassing,exmacenter) )
    },
    addUploadAsset:(id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
      state, dist, block, village, pin, tenth, tenboard, tenfullmark, tenfullmarksecured, twoth, twoboard, twofullmark, twofullmarksecured,
      neet, neetatm,aadharcertif, tenthmarksheet, twothmarksheet, profile_pic, disabilities_pic, neet_pic,
        tenyrpassing,twoyrpassing,exmacenter,aadharcertifprev,disabilities_picprev,neet_picprev,profile_picprev,tenthmarksheetprev,twothmarksheetprev)  => {
      dispatch(addUploadAsset(id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
        state, dist, block, village, pin, tenth, tenboard, tenfullmark, tenfullmarksecured, twoth, twoboard, twofullmark, twofullmarksecured,
        neet, neetatm,aadharcertif,tenthmarksheet, twothmarksheet, profile_pic, disabilities_pic, neet_pic,tenyrpassing,twoyrpassing,exmacenter,aadharcertifprev,disabilities_picprev,neet_picprev,profile_picprev,tenthmarksheetprev,twothmarksheetprev) )
       
    },
  
    onLogout: () => {
      dispatch(onLogout());
    },
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
    SetprofileCat: (payload) => {
      dispatch(SetprofileCat(payload));
    },
    setFname: (payload) => {
      dispatch(setFname(payload));
    },
    setMname: (payload) => {
      dispatch(setMname(payload));
    },
    setGender: (payload) => {
      dispatch(setGender(payload));
    },
    serDisabilities: (payload) => {
      dispatch(serDisabilities(payload));
    },
    setWp: (payload) => {
      dispatch(setWp(payload));
    },
    setSaste: (payload) => {
      dispatch(setSaste(payload));
    },
    setDist: (payload) => {
      dispatch(setDist(payload));
    },
    setBlock: (payload) => {
      dispatch(setBlock(payload));
    },
    setvillage: (payload) => {
      dispatch(setvillage(payload));
    },
    setPin: (payload) => {
      dispatch(setPin(payload));
    },
    setTenScl: (payload) => {
      dispatch(setTenScl(payload));
    },
    setTenSclBord: (payload) => {
      dispatch(setTenSclBord(payload));
    },
    setTenSclpass: (payload) => {
      dispatch(setTenSclpass(payload));
    },
    setTenSclfullmark: (payload) => {
      dispatch(setTenSclfullmark(payload));
    },
    setTenSclfullmarksec: (payload) => {
      dispatch(setTenSclfullmarksec(payload));
    },
   
    setTowClg: (payload) => {
      dispatch(setTowClg(payload));
    },
   
    setTowClgBord: (payload) => {
      dispatch(setTowClgBord(payload));
    },
    setTowClgpass: (payload) => {
      dispatch(setTowClgpass(payload));
    },
    setTowClgfullmark: (payload) => {
      dispatch(setTowClgfullmark(payload));
    },
    setTowClgfullmarksec: (payload) => {
      dispatch(setTowClgfullmarksec(payload));
    },
    setNeet: (payload) => {
      dispatch(setNeet(payload));
    },
    setNeetatm: (payload) => {
      dispatch(setNeetatm(payload));
    },
    setCitycenter: (payload) => {
      dispatch(setCitycenter(payload));
    },
   

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);